import { ReactNode } from 'react';
import { SharedProviders } from 'shared';
import { api } from '@/services/api.config';

// Per-environment URLs from the env files (AWS defaults in .env, overridden by .env.<mode>).
const environmentUrls = {
  embedAssetsUrl: import.meta.env.VITE_EMBED_ASSETS_URL,
  elinxRedirectUrl: import.meta.env.VITE_ELINX_REDIRECT_URL,
};

// The single shared provider the host mounts. The api instance and the asset / eLinx URLs are
// host-injected; toasts, alert dialogs and dialogs are shared's own UI.
export default function SharedServicesProvider({ children }: { children: ReactNode }) {
  return (
    <SharedProviders api={api} environmentUrls={environmentUrls}>
      {children}
    </SharedProviders>
  );
}
